<template>
  <section>
    <h2 class="mt-5">
      <i18n path="common.events" />
    </h2>
    <table class="table">
      <thead>
        <tr>
          <th>
            <i18n path="common.tbTitle.param" />
          </th>
          <th>
            <i18n path="common.tbTitle.desc" />
          </th>
          <th>
            <i18n path="common.tbTitle.args" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>change</td>
          <td>
            <i18n path="region.event.values" />
          </td>
          <td>
            <v-code lang="javascript">
              <pre>
              // 响应数据格式
              // RegionColumns、RegionSelects、RegionGroup 模式有效
              {
                province: { key: string, value: string },
                city: { key: string, value: string },
                area: { key: string, value: string },
                town: { key: string, value: string }
              }
              // RegionCityPicker 模式有效
              [
                { key: string, value: string },
                { key: string, value: string },
                ...
              ]
              </pre>
            </v-code>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
export default {

}
</script>
